import React from "react"

export default function Xing(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 455.7 455.7"
      {...props}
    >
      <path fill="#00605e" d="M0 0h455.7v455.7H0z" />
      <g fill="#fff">
        <path d="M161.9 124.2H89.2l40.7 76-55.3 91.3h72.6l55.4-91.3zM304.6 66.2h76.5l-112.6 198 73.9 125.3h-76.5l-74-125.3z" />
      </g>
    </svg>
  )
}
